import { gql } from '@apollo/client';

export const evaluateApproval = gql`
  mutation evaluateApproval($approvalType: ApprovalType!, $entityInformation: [ApprovalEntityInput]) {
    evaluateApproval(input: { approvalType: $approvalType, entityInformation: $entityInformation }) {
      entityId
      entityNumber
      entityType
      noOfDays
      refundType
      currentTotalTrialLength
      trialExtensionDaysRequested
      standardTrialLength
      netTrialDays
      productName
      edition
      approvalRequired
      slackChannel
      reason
    }
  }
`;

export const initiateProcess = gql`
  mutation initiateProcess(
    $approvalType: ApprovalType!
    $businessKey: String!
    $initiatorComments: String!
    $gsacId: String!
    $entityInformation: [ApprovalEntityInput]
    $additionalInformation: Object
  ) {
    initiateProcess(
      input: {
        approvalType: $approvalType
        businessKey: $businessKey
        initiatorComments: $initiatorComments
        gsacId: $gsacId
        entityInformation: $entityInformation
        additionalInformation: $additionalInformation
      }
    ) {
      processDefinitionId
    }
  }
`;
